export default function blogPost() {
  return {
    _id: false,
    type: 'droplet.blogPost',
    post: null,
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    showImage: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/blog-post/droplet.schema.js